import { render } from "./PerspectiveBar.vue?vue&type=template&id=9e61985c&scoped=true"
import script from "./PerspectiveBar.vue?vue&type=script&lang=js"
export * from "./PerspectiveBar.vue?vue&type=script&lang=js"

import "./PerspectiveBar.vue?vue&type=style&index=0&id=9e61985c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e61985c"]])

export default __exports__